// extracted by mini-css-extract-plugin
module.exports = {"image":"zM-z","loaded":"AM-z","placeholder":"BM-z"};